import { Button } from './button';

interface MobileCTAProps {
  onClick: () => void;
  label?: string;
  suffix?: React.ReactNode;
}

export function MobileCTA({ onClick, label = 'Invest Now', suffix }: MobileCTAProps) {
  return (
    <div className="lg:hidden fixed bottom-0 left-0 right-0 p-4 bg-white border-t border-border z-40">
      <Button className="w-full h-12" onClick={onClick}>
        {label}
        {suffix && <>{suffix}</>}
      </Button>
    </div>
  );
}
